import React, { useState, useEffect } from 'react';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';
import RemoveCircleOutlineTwoToneIcon from '@mui/icons-material/RemoveCircleOutlineTwoTone';

const faqContents = (openInNewTab, navigate) => [
  {
    title: "How does MazingDay work?",
    content: (
      <div className='faqContentBody'>
        <p>
          MazingDay wants you to make the most of every moment. To reach this goal, we ask you to provide personal information, so that we know you better.
          Once we do, our algorithm finds the sequence of activities that suits you and your schedule best. Either you like it and start your MazingDay, or you don’t and swipe
          till the shoe fits your foot.
        </p>
      </div>
    )
  },
  {
    title: "Who can use MazingDay?",
    content: (
      <div className='faqContentBody'>
        <p>
          MazingDay is aimed at everyone from 13 to 113 years old. No matter your age, gender, nationality, education, religion, skills… MazingDay will match who you are but also who you might be, by meeting your unconscious expectations and helping you realize your full potential.
          Let the app surprise you and take you where you have never imagined. Dare saying YES and enjoy the journey!
        </p>
      </div>
    )
  },
  {
    title: "What kind of activities will I get to do?",
    content: (
      <div className='faqContentBody'>
        <p>
          Activities picked up by our algorithm are classified in more than 10 categories, exhaustively covering anything you can do outside home. The app is constantly updated and the diversity of content is ever growing. Stay in or step out of your comfort zone?
          Be reassured or be surprised? You decide. MazingDay is here to accompany you into a real, steady and fulfilling personal growth, always with fun along the way.
        </p>
      </div>
    )
  },
  {
    title: "There is so much to do! How do I manage my time?",
    content: (
      <div className='faqContentBody'>
        <p>
          Our algorithm will take care of it for you! Depending on your availability, the activities will be sequenced smoothly within your allotted time. You are free from morning til night?
          The app will suggest you activities for the whole day, including lunch and dinner breaks, taking into consideration your mode of transportation and your availability. You have started a sequence of activities but can’t make it to the next one because of traffic, something unforeseen or simply because you changed your mind? No problem at all! MazingDay is not a booking platform, thus plans can be changed whenever you want.
        </p>
      </div>
    )
  },
  {
    title: "It all sounds great, but what about my private data?",
    content: (
      <div className='faqContentBody'>
        <p>
          Let’s be very clear: we commit not to sell or disclose any personal information without your consent. This being said, any personal data that we might ask (age, gender, nationality, religion, height/weight, health, mobility limitation, etc.) is collected only with the purpose of matching our activities suggestions with your profile.
        </p>
      </div>
    )
  },
  {
    title: "Amazing! How do I subscribe?",
    content: (
      <div className='faqContentBodySix'>
        <p>MazingDay offers you the following subscription plans to fit your needs:</p>
        <ul>
          <li>One month</li>
          <li>Three months</li>
          <li>One year</li>
        </ul>
        <p>
          <span style={{ color: "#448DF0", cursor: "pointer" }} onClick={() => openInNewTab("https://apps.apple.com/ae/app/mazingday/id1588274415")}> Download </span>
          MazingDay mobile app from
          <span style={{ color: "#448DF0", cursor: "pointer" }} onClick={() => openInNewTab("https://play.google.com/store/apps/details?id=com.alpeyg.mazingday&pli=1")}> Google Play Store </span>
          or
          <span style={{ color: "#448DF0", cursor: "pointer" }} onClick={() => openInNewTab("https://apps.apple.com/ae/app/mazingday/id1588274415")}> App Store </span>
          and follow the steps!
        </p>
      </div>
    )
  },
  {
    title: "I am a provider, how can I register my activities or services in your database?",
    content: (
      <div className='faqContentBodySeven'>
        <p>
          We are happy to welcome you in our Mazing network! MazingDay is a wonderful tool for you as it matches your offer of activities or services with the right customer base. Thus, you can increase your visibility with relevant and useful reviews adhering to our code of conduct. You can also increase your visitor and sales conversion rates, providing additional revenue. Last but not least, you can also make new business connections or even find potential new talents amongst your visitors.
          <span style={{ color: "blue", cursor: "pointer" }} onClick={() => navigate('/provider')}> Contact us </span> to start our journey together.
        </p>
      </div>
    )
  }
];

const Faq = ({ navigate }) => {
  const [activeFaq, setActiveFaq] = useState({});
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const openInNewTab = (url) => {
    window.open(url, '_blank', 'noreferrer');
  };

  const toggleFaq = (index) => {
    setActiveFaq((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <div className='faqContainer'>
      <header className='faqHeader'>
        <h1 className='titleInFAQ' style={isSmallScreen ? { fontWeight: "bold" } : {}}>
          {isSmallScreen ? "FAQs" : "Frequently asked questions"}
        </h1>
      </header>

      <div className='faq'>
        {faqContents(openInNewTab, navigate).map((faq, index) => (
          <div className='faqContent' key={index}>
            <div className='faqContentHead'>
              <h2 className='faqContentTitle'>{faq.title}</h2>
              {activeFaq[index] ? (
                <RemoveCircleOutlineTwoToneIcon
                  className='faqContentIcon'
                  sx={{ fontSize: isSmallScreen ? "22px" : "52px", color: "#BDBDBD" }}
                  onClick={() => toggleFaq(index)}
                />
              ) : (
                <AddCircleOutlineTwoToneIcon
                  className='faqContentIcon'
                  sx={{ fontSize: isSmallScreen ? "22px" : "52px", color: "#BDBDBD" }}
                  onClick={() => toggleFaq(index)}
                />
              )}
            </div>
            {activeFaq[index] && faq.content}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;